import $ from 'jquery';

/**
 * Show loading and disable form submit button
 * @param {jQuery} e - submit event
 */
function showLoading(e) {
  const form = $(e.target);
  const submit = form.find('button.form__submit-button');
  submit.addClass('btn--loading').prop('disabled', true);
}

function init() {
  const form = $('.form--submit-loader');
  form.on('submit', showLoading);
}

export default { init };
export { init };
